import addressParse from '@loggi/js/address/address-parse';

const parseGeocodeFromAddress = address => {
  let geocode = (address && address.geocode) || address;
  if (typeof geocode === 'string') geocode = addressParse(geocode);
  return geocode;
};

export default parseGeocodeFromAddress;
